import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const LogoStyle = styled.img`
   
`;
export const CadastarStyle = styled(Link)`
    color: #000;
    text-decoration: underline;
    font-weight: bold;
    font-size: 0.9em;
    &:hover{
        color: #000;
        opacity: 0.65;
    }
    
`;
export const EsqueceuStyle = styled(Link)`
    color: #000;
    text-decoration: underline;
    font-size: 0.9em;
    margin-top:0.5em;
    & b{
        font-weight: bold;
    }
    &:hover{
        color: #000;
        opacity: 0.65;
    }
`;
export const BoxLogin = styled.div`
    border: 1px solid #8591a5;
    margin: 0 auto;
    & label{
        text-align: center;
        width: 100%;
    
    }
`;